import { render, staticRenderFns } from "./SelectSubjectsJoined.vue?vue&type=template&id=1532e08c&scoped=true"
import script from "./SelectSubjectsJoined.vue?vue&type=script&lang=js"
export * from "./SelectSubjectsJoined.vue?vue&type=script&lang=js"
import style0 from "./SelectSubjectsJoined.vue?vue&type=style&index=0&id=1532e08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1532e08c",
  null
  
)

export default component.exports